module.exports = __webpack_public_path__ + "img/obras2.6f0fd2e0.svg";